import { render, staticRenderFns } from "./zlfymxd.vue?vue&type=template&id=2266bc9c&scoped=true&"
import script from "./zlfymxd.vue?vue&type=script&lang=js&"
export * from "./zlfymxd.vue?vue&type=script&lang=js&"
import style0 from "./zlfymxd.vue?vue&type=style&index=0&id=2266bc9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266bc9c",
  null
  
)

export default component.exports